import {useUpdateDrugsCategoryStatus} from '@/modules/basic-data/categories/api'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useDrugsCategoryContext} from '@/shared/contexts/drugs-category'
import {LuTag, LuTags} from 'react-icons/lu'

export function DrugsCategorySummary() {
  const {category, isSubcategory} = useDrugsCategoryContext()
  const updateStatus = useUpdateDrugsCategoryStatus()
  const canManageBasicData = useCan('basic_data.manage')

  return (
    <ResourceDrawerSummary
      title={category.name}
      icon={isSubcategory ? LuTags : LuTag}
      status={category.status}
      {...(canManageBasicData && {
        onChangeStatus: status => updateStatus({id: category.id, status}),
      })}
    />
  )
}
